export enum ICountryTabs {
  addNewCountry = "1",
  countryTable = "2",
}
